<template>
<form id="signup-form" @submit.prevent="processForm">
    <div class="success-msg text-center">
      <h2>Thank you for your interest!</h2>
      <p>We'll be in touch shortly</p>
    </div>
    <div class="input-container">
      <div class="row">
          <div class="col">
            <div class="mb-3">
              <label class="label">First Name</label>
              <input type="text" class="form-control input" name="firstname" v-model="firstname">
            </div>
          </div>
          <div class="col">
            <div class="mb-3">
              <label class="label">Last Name</label>
               <input type="text" class="form-control input" name="lastname" v-model="lastname">
            </div>
          </div>
      </div>
      <!-- email -->
      <div class="mb-3">
        <label class="label">Email</label>
        <input type="email" class="form-control input" name="email" v-model="email">
      </div>
      <!-- company -->
      <div class="mb-3">
        <label class="label">Company</label>
        <input type="text" class="form-control input" name="company" v-model="company">
      </div>
      <!-- submit button -->
      <div class="mb-3 mt-4 pt-2">
        <button type="submit" class="submit btn_maropost">Book today to start automating your journeys</button>
      </div>
    </div>
    </form>
  <!-- <form
    action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
    method="POST"
  >
    <input type="hidden" name="oid" value="00DA0000000IVhu" />
    <input type="hidden" name="retURL" value="https://journeybuilder.maropost.com?ref=success" />
    <input type=hidden name="lead_source" value="journey builder demo">
    <div class="row">
      <div class="col">
        <div
          class="mb-3"
          :class="{ 'form-group--error': $v.first_name.$error, 'form-group--loading': $v.first_name.$pending }"
        >
          <label for="email" class="label">First Name</label>
          <input
            type="text"
            name="first_name"
            id="first_name"
            v-model="$v.first_name.$model"
            class="form-control"
            :class="{'input': true, 'is-danger': $v.first_name.$invalid }"
            novalidate
          />
          <b-alert
            variant="danger"
            fade
            v-if="!$v.first_name.required"
            :show="!$v.first_name.required"
          >Your First Name is required</b-alert>
        </div>
      </div>
      <div class="col">
        <div
          class="mb-3"
          :class="{ 'form-group--error': $v.last_name.$error, 'form-group--loading': $v.last_name.$pending }"
        >
          <label for="email" class="label">Last Name</label>
          <input
            type="text"
            name="last_name"
            id="last_name"
            v-model="$v.last_name.$model"
            class="form-control"
            :class="{'input': true }"
            novalidate
          />
        </div>
      </div>
    </div>

    <div
      class="mb-3"
      :class="{ 'form-group--error': $v.company.$error, 'form-group--loading': $v.company.$pending }"
    >
      <label for="email" class="label">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        v-model="$v.company.$model"
        class="form-control"
        :class="{'input': true, 'is-danger': $v.company.$invalid }"
        placeholder="Your Company"
        novalidate
      />
      <b-alert
        variant="danger"
        fade
        v-if="!$v.company.required"
        :show="!$v.company.required"
      >Your Company is required</b-alert>
    </div>

    <div
      class="mb-3"
      :class="{ 'form-group--error': $v.email_address.$error, 'form-group--loading': $v.email_address.$pending }"
    >
      <label for="email" class="label">Company Email</label>
      <input
        type="email"
        name="email"
        id="email"
        v-model="$v.email_address.$model"
        class="form-control"
        :class="{'input': true, 'is-danger': $v.email_address.$invalid }"
        placeholder="Email Address"
        novalidate
      />
      <b-alert
        variant="danger"
        fade
        v-if="!$v.email_address.required"
        :show="!$v.email_address.required"
      >Your Company Email is required</b-alert>
      <b-alert
        variant="danger"
        fade
        v-if="!$v.email_address.$email"
        :show="$v.email_address.$invalid"
      >Please provide a proper email!</b-alert>
    </div>

    <div class="mb-3 mt-4 pt-2">
      <button
        class="submit btn_maropost"
        type="submit"
        style="width:100%"
        :disabled="submitStatus === 'PENDING'"
      >Book today to start automating your journeys</button>
      <b-alert
        :show="submitStatus === 'OK'"
        variant="success"
        dismissible
        fade
        v-if="submitStatus === 'OK'"
      >Thanks for your submission!</b-alert>
      <b-alert
        :show="submitStatus === 'ERROR'"
        variant="danger"
        dismissible
        fade
        v-if="submitStatus === 'ERROR'"
      >Please Fill Out All Fields Above.</b-alert>
      <b-alert
        :show="submitStatus === 'PENDING'"
        variant="primary"
        dismissible
        fade
        v-if="submitStatus === 'PENDING'"
      >Sending...</b-alert>
    </div>
  </form> -->
</template>
<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
export default {
   data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      company: ''
    };
  },
  methods: {
    processForm: function() {
       // Create the new request 
    var xhr = new XMLHttpRequest();
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/8225183/6a627f52-c49c-4fff-9e02-0da2127716ce'
    //Get Form
    var form = document.getElementById('signup-form');
    //Get Form data
    var email = document.getElementsByName('email')[0].value;
    var company = document.getElementsByName('company')[0].value;
    var fname = document.getElementsByName('firstname')[0].value;
    var lname = document.getElementsByName('lastname')[0].value;
    console.log(email);
    //Get time 
    var submitTime = new Date().getTime();
    
    // Example request JSON:
    var formdata = {
      "submittedAt": submitTime,
      "fields": [
        {
          "name": "email",
          "value": email
        },
        {
          "name": "firstname",
          "value": fname
        },
        {
          "name": "lastname",
          "value": lname
        },
        {
          "name": "company",
          "value": company
        }
      ]
    }

    var final_data = JSON.stringify(formdata)

    xhr.open('POST', url);
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function() {
        if(xhr.readyState == 4 && xhr.status == 200) { 
            console.log(xhr.responseText); // Returns a 200 response if the submission is successful.
            form.classList.add('success');
        } else if (xhr.readyState == 4 && xhr.status == 400){ 
            console.log(xhr.responseText); // Returns a 400 error the submission is rejected.          
        } else if (xhr.readyState == 4 && xhr.status == 403){ 
            console.log(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.           
        } else if (xhr.readyState == 4 && xhr.status == 404){ 
            console.log(xhr.responseText); //Returns a 404 error if the formGuid isn't found     
        }
       }
    // Sends the request 
    xhr.send(final_data)
    }
  },
  // props: ["industry"],

  // data() {
  //   return {
  //     email_address: "",
  //     first_name: "",
  //     last_name: "",
  //     company: "",
  //     submitStatus: null
  //   };
  // },

  // computed: {
  //   isRequired() {
  //     return true;
  //   },
  //   isValid() {
  //     return (
  //       this.first_name !== "" &&
  //       this.company !== "" &&
  //       this.email_address !== ""
  //     );
  //   }
  // },

  // validations: {
  //   email_address: {
  //     email,
  //     required: true,
  //     async isUnique(value) {
  //       // standalone validator ideally should not assume a field is required
  //       if (value === "") return true;

  //       // simulate async call, fail for all logins with even length
  //       return new Promise((resolve, reject) => {
  //         setTimeout(() => {
  //           resolve(typeof value === "string" && value.length % 2 !== 0);
  //         }, 350 + Math.random() * 300);
  //       });
  //     }
  //   },
  //   first_name: { required: true },
  //   last_name: { required: false },
  //   company: { required: true }
  // },

  // methods: {
  //   async submit() {
  //     this.$v.$touch();

  //     if (!this.isValid) {
  //       this.submitStatus = "ERROR";
  //     } else {
  //       this.submitStatus = "PENDING";

  //       const data = {
  //         oid: "00DA0000000IVhu",
  //         retURL: "https://journeybuilder.maropost.com",
  //         email: this.email_address,
  //         first_name: this.first_name,
  //         last_name: this.last_name,
  //         company: this.company
  //       };

  //       try {
  //         let res = await axios({
  //           method: "post",
  //           url: "http://go.maropost.com/l/597851/2020-05-13/cnhcb",
  //           data
  //         });

  //         console.log("res", res);
  //         this.submitStatus = "OK";

  //         this.$ga.event({
  //           eventCategory: "Subscribe",
  //           eventAction: "submit",
  //           eventValue: opts
  //         });
  //       } catch (error) {
  //         console.log(error);
  //         this.submitStatus = "ERROR";
  //       }
  //     }
  //   }
  // }
};
</script>
<style lang="scss" scoped>
</style>